"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SrOnly = exports.Coin = exports.ShoppingBag = exports.Counter = exports.CartIcon = exports.SliceFlex = void 0;

var _react = _interopRequireDefault(require("react"));

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactSpring = require("react-spring");

var _slice = require("@lce/slice");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ShoppingBagSvg = function ShoppingBagSvg(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("g", {
    fill: "#ff731d"
  }, _react["default"].createElement("path", {
    d: "M631.2 743.8H79.6C35.7 743.8 0 708.1 0 664.2c0-1.5.1-3 .4-4.5l84.9-488c2.2-12.7 13.2-22 26.1-22h488c12.9 0 23.9 9.3 26.1 22l84.9 488c.3 1.5.4 3 .4 4.5 0 43.9-35.7 79.6-79.6 79.6zM53.1 666.1c1 13.7 12.5 24.6 26.5 24.6h551.7c14 0 25.5-10.9 26.5-24.6l-80.6-463.4H133.7z"
  }), _react["default"].createElement("path", {
    d: "M531.4 277.8h-53V176c0-67.8-55.1-122.9-122.9-122.9s-123 55.1-123 122.9v101.8h-53V176c0-97 78.9-176 176-176 97 0 176 78.9 176 176v101.8z"
  })));
};

ShoppingBagSvg.defaultProps = {
  viewBox: "0 0 710.8 743.8",
  xmlns: "http://www.w3.org/2000/svg"
};
var SliceFlex = (0, _styledComponents["default"])(_slice.Flex).attrs({
  flexDirection: 'column',
  alignItems: 'center'
})(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  width: 36px;\n  height: 36px;\n  position: relative;\n"], ["\n  width: 36px;\n  height: 36px;\n  position: relative;\n"])));
exports.SliceFlex = SliceFlex;
var CartIcon = (0, _styledComponents["default"])(_slice.Box)(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  position: relative;\n  cursor: pointer;\n\n  /* ", " {\n    margin-top: 5px;\n  } */\n"], ["\n  position: relative;\n  cursor: pointer;\n\n  /* ", " {\n    margin-top: 5px;\n  } */\n"])), _slice.mediaQueries[0]);
exports.CartIcon = CartIcon;
var Counter = (0, _styledComponents["default"])(_reactSpring.animated.div)(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  color: ", ";\n  width: 26px;\n  height: 20px;\n  position: absolute;\n  top: 20px;\n  left: calc(50%);\n  transform: translateX(-50%);\n\n  ", " {\n    width: 20px;\n    height: 15px;\n    top: 12px;\n  }\n"], ["\n  color: ", ";\n  width: 26px;\n  height: 20px;\n  position: absolute;\n  top: 20px;\n  left: calc(50%);\n  transform: translateX(-50%);\n\n  ", " {\n    width: 20px;\n    height: 15px;\n    top: 12px;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
}, _slice.mediaQueries[0]);
exports.Counter = Counter;
var ShoppingBag = (0, _styledComponents["default"])(ShoppingBagSvg)(templateObject_4 || (templateObject_4 = (0, _tslib.__makeTemplateObject)(["\n  width: 42px;\n  height: auto;\n\n  ", " {\n    width: 32px;\n  }\n"], ["\n  width: 42px;\n  height: auto;\n\n  ", " {\n    width: 32px;\n  }\n"])), _slice.mediaQueries[0]);
exports.ShoppingBag = ShoppingBag;
var Coin = (0, _styledComponents["default"])(_slice.Flex)(templateObject_5 || (templateObject_5 = (0, _tslib.__makeTemplateObject)(["\n  border: 1px solid grey;\n  border-radius: 20px;\n  width: 10px;\n  height: 10px;\n  flex: 0 0 auto;\n"], ["\n  border: 1px solid grey;\n  border-radius: 20px;\n  width: 10px;\n  height: 10px;\n  flex: 0 0 auto;\n"])));
exports.Coin = Coin;

var SrOnly = _styledComponents["default"].span(templateObject_6 || (templateObject_6 = (0, _tslib.__makeTemplateObject)(["\n  border-width: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"], ["\n  border-width: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"])));

exports.SrOnly = SrOnly;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;